import { SortableColumn, SortDirection } from '../types';

export class SortHelper {

  static isDateColumn(column: SortableColumn): boolean {
    return column === 'executionDateFormatted' || column === 'assignmentDateFormatted';
  }

  static isTimeColumn(column: SortableColumn): boolean {
    return column === 'hour';
  }

  static compareTime(
    timeA: string | undefined,
    timeB: string | undefined,
    direction: SortDirection
  ): number {
    if (!timeA || !timeB) return 0;
    
    const toMinutes = (time: string): number => {
      const [hours, minutes] = time.split(':').map(Number);
      return (hours || 0) * 60 + (minutes || 0);
    };
    
    const minutesA = toMinutes(timeA);
    const minutesB = toMinutes(timeB);
    
    if (minutesA < minutesB) return -direction;
    if (minutesA > minutesB) return direction;
    return 0;
  }

  static compareValues(
    valueA: string | number | boolean | undefined,
    valueB: string | number | boolean | undefined,
    direction: SortDirection
  ): number {
    if (valueA === undefined || valueB === undefined) return 0;
    if (valueA < valueB) return -direction;
    if (valueA > valueB) return direction;
    return 0;
  }
}
